import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=c3cb61bc&scoped=true"
import script from "./PC.vue?vue&type=script&lang=js"
export * from "./PC.vue?vue&type=script&lang=js"
import style0 from "./PC.vue?vue&type=style&index=0&id=c3cb61bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cb61bc",
  null
  
)

export default component.exports